// src/components/LeadHelpModal.jsx — Keyboard shortcuts cheat sheet dialog
import React from 'react';
import { Modal } from 'react-bootstrap';
import { Keyboard, X } from 'lucide-react';

export default function LeadHelpModal({ show, onHide }) {
  const shortcuts = [
    { key: '/', description: 'Focus search input' },
    { key: 'Ctrl + Z', description: 'Undo last inline or bulk edit' },
    { key: '?', description: 'Open this keyboard shortcuts dialog' },
    { key: '↑ / ↓', description: 'Navigate rows up and down in table' },
    { key: '→  or  ]', description: 'Next page' },
    { key: '←  or  [', description: 'Previous page' },
    { key: 'Shift + →', description: 'Jump to last page' },
    { key: 'Shift + ←', description: 'Jump to first page' },
    { key: 'Enter', description: 'Open focused lead detail page' },
    { key: 'Space', description: 'Toggle checkbox selection for focused row' },
    { key: 'S', description: 'Open status popover for focused row' },
    { key: 'A', description: 'Open agent popover for focused row' },
    { key: 'C', description: 'Call focused lead' },
    { key: 'W', description: 'Open WhatsApp chat for focused lead' },
    { key: 'Esc', description: 'Close popovers / modals or return to list' },
  ];

  return (
    <Modal show={show} onHide={onHide} centered className="dark-theme-modal">
      <Modal.Header style={{ borderBottom: '1px solid #334155', background: '#0f172a', color: '#f8fafc' }}>
        <Modal.Title style={{ fontSize: '16px', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Keyboard size={18} style={{ color: '#38bdf8' }} /> Keyboard Shortcuts
        </Modal.Title>
        <button type="button" className="btn-close-custom" onClick={onHide} style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer' }}>
          <X size={18} />
        </button>
      </Modal.Header>
      <Modal.Body style={{ background: '#0f172a', color: '#e2e8f0', padding: '20px', maxHeight: '75vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {shortcuts.map((s) => (
            <div
              key={s.key}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '8px 12px',
                borderRadius: '8px',
                background: '#1e293b',
                border: '1px solid #334155',
              }}
            >
              <span style={{ fontSize: '13px', color: '#cbd5e1' }}>{s.description}</span>
              <kbd
                style={{
                  background: '#090d16',
                  color: '#38bdf8',
                  padding: '3px 8px',
                  borderRadius: '4px',
                  fontSize: '12px',
                  fontFamily: 'monospace',
                  border: '1px solid #334155',
                }}
              >
                {s.key}
              </kbd>
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
}
